import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useState } from "react";
import { logUserAction } from "../../utils/analytics";
import { useNavigate } from "react-router-dom";
import { colors } from "../../theme/theme";

const getPercentage = (salePercentage) => {
  return (
    Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(salePercentage * 100) + "%"
  );
};

const SearchCategoryCard = ({ categoryCollection }) => {
  const navigate = useNavigate();

  const [currentImageIndex, setCurrentImageIndex] = useState({});
  const [selectedProduct, setSelectedProduct] = useState(null);

  const smallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const mediumScreen = useMediaQuery((theme) =>
    theme.breakpoints.between("sm", "lg"),
  );

  const query = localStorage.getItem("query");

  return (
    <Box sx={{ px: 2, pb: 2 }}>
      <Grid container spacing={2}>
        {categoryCollection.map((product, index) => {
          const images = product?.images || [product?.image_url];
          const currentIndex = currentImageIndex[product.product_id] || 0;
          const hasMultipleImages = images.length > 1;

          return (
            <Grid item xs={6} sm={4} md={3} key={index}>
              <Card
                onClick={async () => {
                  await logUserAction({
                    action: "product_click",
                    data: {
                      product_id: product.product_id || null,
                      product_title: product.title || null,
                      brand: product.brand || null,
                      product_price:
                        product?.price?.discounted ||
                        product?.price?.original ||
                        null,
                      currency: product?.price?.currency || null,
                      product_image: product?.image_url || null,
                    },
                    timestamp: new Date().toISOString(),
                  });

                  if (product.url) {
                    await logUserAction({
                      action: "checkout_redirect",
                      data: {
                        product_id: product.product_id || null,
                        redirect_url: product.url || null,
                      },
                      timestamp: new Date().toISOString(),
                    });

                    window.open(product.url, "_blank");
                  } else {
                    await logUserAction({
                      action: "product_click",
                      data: {
                        product_id: product.product_id || null,
                        product_title: product.title || null,
                        brand: product.brand || null,
                        product_price:
                          product?.price?.discounted ||
                          product?.price?.original ||
                          null,
                        currency: product?.price?.currency || null,
                        product_image: product?.image_url || null,
                      },
                      timestamp: new Date().toISOString(),
                    });
                    setSelectedProduct(index);

                    navigate("/product", {
                      state: { product, searchQuery: query },
                    });
                  }
                }}
                sx={{
                  height: "100%",
                  borderRadius: "12px",
                  display: "flex",
                  flexDirection: "column",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                  position: "relative",
                  transition: "transform 0.2s ease, box-shadow 0.2s ease",
                  border: "1px solid #eee",
                  backgroundColor: "#fff",
                  overflow: "hidden",
                  cursor: "pointer",
                  "&:hover": {
                    boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
                    transform: "translateY(-2px)",
                  },
                }}
              >
                {product?.price?.sale_percentage != null && (
                  <Box
                    sx={{
                      position: "absolute",
                      top: "12px",
                      right: "12px",
                      backgroundColor: "#e74c3c",
                      color: "#fff",
                      borderRadius: "4px",
                      padding: "4px 8px",
                      fontSize: "11px",
                      fontFamily: "Poppins-SemiBold",
                      fontWeight: 600,
                      zIndex: 2,
                    }}
                  >
                    -{Math.round(product?.price?.sale_percentage)}%
                  </Box>
                )}

                <Box
                  sx={{
                    position: "relative",
                    width: "100%",
                    height: smallScreen ? "250px" : "280px",
                    overflow: "hidden",
                    backgroundColor: "#f8f8f8",
                  }}
                >
                  {/* <img
                    src={images[currentIndex]}
                    alt=""
                    onError={(e) =>
                      (e.target.src = require("../../assets/images/no_image.png"))
                    }
                    style={{
                      objectFit: "contain",
                      width: "100%",
                      height: "100%",
                    }}
                  />

                  {hasMultipleImages && (
                    <>
                      <IconButton
                        sx={{
                          position: "absolute",
                          left: 8,
                          top: "50%",
                          transform: "translateY(-50%)",
                          backgroundColor: "rgba(0,0,0,0.5)",
                          color: "white",
                          "&:hover": {
                            backgroundColor: "rgba(0,0,0,0.7)",
                          },
                          zIndex: 2,
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          setCurrentImageIndex((prev) => ({
                            ...prev,
                            [product.product_id]:
                              ((prev[product.product_id] || 0) -
                                1 +
                                images.length) %
                              images.length,
                          }));
                        }}
                      >
                        <NavigateBefore />
                      </IconButton>
                      <IconButton
                        sx={{
                          position: "absolute",
                          right: 8,
                          top: "50%",
                          transform: "translateY(-50%)",
                          backgroundColor: "rgba(0,0,0,0.5)",
                          color: "white",
                          "&:hover": {
                            backgroundColor: "rgba(0,0,0,0.7)",
                          },
                          zIndex: 2,
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          setCurrentImageIndex((prev) => ({
                            ...prev,
                            [product.product_id]:
                              ((prev[product.product_id] || 0) + 1) %
                              images.length,
                          }));
                        }}
                      >
                        <NavigateNext />
                      </IconButton>
                      <Box
                        onClick={(e) => {}}
                        sx={{
                          position: "absolute",
                          bottom: 8,
                          left: 0,
                          right: 0,
                          display: "flex",
                          justifyContent: "center",
                          gap: 0.5,
                          zIndex: 2,
                        }}
                      >
                        {images.map((_, idx) => (
                          <Box
                            key={idx}
                            sx={{
                              width: 8,
                              height: 8,
                              borderRadius: "50%",
                              backgroundColor:
                                currentIndex === idx
                                  ? "white"
                                  : "rgba(255,255,255,0.5)",
                            }}
                          />
                        ))}
                      </Box>
                    </>
                  )} */}
                  <Box
                    sx={{
                      height: "100%",
                      overflowX: "auto",
                      overflowY: "hidden",
                      display: "flex",
                      scrollSnapType: "x mandatory",
                      scrollBehavior: "smooth",
                      "&::-webkit-scrollbar": {
                        height: 5,
                      },
                      "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "rgba(0,0,0,0.3)",
                        borderRadius: 4,
                      },
                      "&::-webkit-scrollbar-track": {
                        backgroundColor: "rgba(0,0,0,0.05)",
                      },
                    }}
                  >
                    {images.map((img, idx) => (
                      <Box
                        key={idx}
                        sx={{
                          minWidth: "100%",
                          height: "100%",
                          scrollSnapAlign: "center",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          src={img}
                          alt=""
                          onError={(e) =>
                            (e.target.src = require("../../assets/images/no_image.png"))
                          }
                          style={{
                            objectFit: "cover",
                            width: "100%",
                            height: "100%",
                          }}
                        />
                      </Box>
                    ))}
                  </Box>
                </Box>

                <CardContent
                  sx={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden",
                    padding: "16px !important",
                    backgroundColor: "#fff",
                  }}
                >
                  {/* Brand Badge */}
                  {product?.brand && (
                    <Typography
                      sx={{
                        fontSize: "10px",
                        fontFamily: "Poppins-Medium",
                        fontWeight: 500,
                        color: "#999",
                        textTransform: "uppercase",
                        mb: 1,
                      }}
                    >
                      {product?.brand}
                    </Typography>
                  )}

                  <Typography
                    variant="h6"
                    sx={{
                      fontSize: "15px",
                      fontWeight: 600,
                      color: "#1a1a1a",
                      fontFamily: "Poppins-SemiBold",
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      lineHeight: 1.4,
                      mb: 0.75,
                    }}
                  >
                    {product?.title}
                  </Typography>

                  {(product?.description || product?.enhanced_description) && (
                    <Typography
                      variant="body2"
                      sx={{
                        fontSize: "12px",
                        color: "#666",
                        fontFamily: "Poppins-Regular",
                        lineHeight: 1.5,
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        mb: 2,
                      }}
                    >
                      {product?.description || product?.enhanced_description}
                    </Typography>
                  )}

                  <Box sx={{ mt: "auto", pt: 1, borderTop: "1px solid #f0f0f0" }}>
                    <Box sx={{ display: "flex", alignItems: "baseline", gap: 1 }}>
                      {product?.price?.discounted && (
                        <Typography
                          sx={{
                            fontSize: "18px",
                            fontWeight: 700,
                            color: "#1a1a1a",
                            fontFamily: "Poppins-Bold",
                          }}
                        >
                          {product?.price?.discounted}{" "}
                          {product?.price?.currency}
                        </Typography>
                      )}
                      {product?.price?.discounted && (
                        <Typography
                          sx={{
                            fontSize: "14px",
                            color: "#999",
                            fontFamily: "Poppins-Regular",
                            textDecoration: "line-through",
                          }}
                        >
                          {product?.price?.original}
                        </Typography>
                      )}
                      {!product?.price?.discounted && (
                        <Typography
                          sx={{
                            fontSize: "18px",
                            fontWeight: 700,
                            color: "#1a1a1a",
                            fontFamily: "Poppins-Bold",
                          }}
                        >
                          {product?.price?.original || "N/A"}{" "}
                          {product?.price?.currency || ""}
                        </Typography>
                      )}
                    </Box>
                  </Box>

                  {/* {product?.variants?.length > 0 && (
                        <Box sx={{ mt: "auto" }}>
                          <Typography
                            variant="caption"
                            sx={{ fontWeight: "bold" }}
                          >
                            Sizes:
                          </Typography>
                          <Box
                            sx={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: 0.5,
                              mt: 0.5,
                            }}
                          >
                            {product.variants.map((variant, i) => (
                              <Chip
                                key={i}
                                label={variant.size}
                                size="small"
                                sx={{
                                  fontSize: "0.6rem",
                                  height: "20px",
                                  backgroundColor: "#e0e0e0",
                                }}
                              />
                            ))}
                          </Box>
                        </Box>
                      )} */}

                  {/* <Stack
                        direction="row"
                        sx={{
                          mt: "auto",
                          alignItems: "center",
                        }}
                      >
                        <StoreOutlined
                          sx={{ color: "#1B1211", fontSize: "14px" }}
                        />
                        <Typography
                          variant="caption"
                          sx={{
                            color: "#1B1211",
                            ml: 0.5,
                            fontSize: "0.7rem",
                          }}
                        >
                          shop no. 504 3rd floor luckyone mall
                        </Typography>
                      </Stack> */}
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default SearchCategoryCard;
